import React, { useEffect, useState } from "react";
import axios from "axios";
import { Api } from "../../api";
import { Headers } from "../../api/actions";
import Loading from "../../components/loading/loading";
import { useParams } from "react-router";

import NavbarLeft from "../../components/navbar/navbar_left";
import NavbarTop from "../../components/navbar/navbar_top";
import ExamsContent from "./component/exams-content";
import axiosInstance from "../../api/axios_instance";

const Exams = () => {
  const { page, search } = useParams();
  const pageCount = +page.slice(page.indexOf(":") + 1, page.length);
  const searchKeyword = search.slice(search.indexOf(":") + 1, search.length);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [perpage, setPerpage] = useState(0);
  const [PageSize, setPageSize] = useState(10);

  useEffect(() => {
    GetData(
      setData,
      setLoading,
      pageCount,
      setPerpage,
      PageSize,
      searchKeyword
    );
  }, [pageCount, PageSize, searchKeyword]);

  const ObJectArrayData = [
    {
      id: 2,
      href: `/exams/page:${1}/search:${""}`,
      title: "الاختبارات",
    },
  ];

  if (!loading) {
    return (
      <section className="main">
        <NavbarLeft />
        <div className="main-body">
          <NavbarTop ArrayData={ObJectArrayData} />
          <div className="main-body__content">
            <Loading />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="main">
      <NavbarLeft />
      <div className="main-body">
        <NavbarTop ArrayData={ObJectArrayData} />
        <div className="main-body__content">
          <ExamsContent
            ArrayData={data}
            perpage={perpage}
            pagenumber={pageCount}
            setLoading={setLoading}
            PageSize={PageSize}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </section>
  );
};

export default Exams;

const GetData = async (
  setData,
  setLoading,
  pageCount,
  setPerpage,
  PageSize,
  searchKeyword
) => {
  var data = new FormData();
  data.append("pageNumber", pageCount);
  data.append("pageSize", PageSize);
  data.append("searchKeyword", searchKeyword);

  const options = {
    method: "post",
    url: `${Api}Test/SearchForTests`,
    headers: Headers,
    data,
  };
  await axiosInstance(options)
    .then(function (response) {
      setData(response.data.responseObject.items);
      setLoading(true);

      setPerpage(
        Math.ceil(
          response.data.responseObject.totalItemsCount /
            response.data.responseObject.pageSize
        )
      );
    })
    .catch(function (error) {
      setLoading(true);
    });
};
